exports.config = {
  'logLevel': 'info', // Can be either "info", "debug", "warn", or "silent"
  'browsers': ['chrome'] // Choose browsers for synchronized browser testing
}
